var _excluded = ["children", "isSelected", "className", "tag", "type"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
require("./filter-tile.css");
var styles = {
  "filterTile": "filterTile-1GrEH",
  "filterTileActive": "filterTileActive-1OdZU",
  "filterTileInactive": "filterTileInactive-1c2fm"
};
var FilterTile = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      isSelected,
      className,
      tag,
      type
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag;
  if (!children) return null;
  return /*#__PURE__*/React.createElement(Tag, _extends({
    ref: ref,
    className: cs(styles.filterTile, {
      [styles.filterTileActive]: isSelected,
      [styles.filterTileInactive]: !isSelected
    }, className),
    type: Tag === 'button' ? type : undefined
  }, otherProps), children);
});
FilterTile.propTypes = {
  /** the text to display in the tile */
  children: PropTypes.node.isRequired,
  /** if true, the tile is active and styled as such, otherwise is inactive */
  isSelected: PropTypes.bool,
  /** custom classname to customize styling */
  className: PropTypes.string,
  /** the HTML tag used to render each tile */
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};
FilterTile.defaultProps = {
  isSelected: false,
  className: null,
  tag: 'button',
  type: 'button'
};
export default FilterTile;